import IdManage from '../IdManager/index'

export default function (superClass) {
  return class extends superClass{
    constructor(...arg) {
      // @ts-ignore
      super(...arg)
    }

    install() { }
    destroy() { }
    display() { return "" }


    getShapePosition(shapeId) {
      let { id, type, name, matrix } = this.shapes[shapeId]

      return {
        x: matrix[4],
        y: matrix[5]
      }
    }

    // snap manager 
    beforeSnap(excludedId) {
      let snappableX = []
        , snappableY = []
        , shapeIdList = Object.keys(this.shapes)
        , lineIdList = Object.keys(this.lines)
        , position

      for (let i = 0; i < shapeIdList.length; i++) {
        if (shapeIdList[i] !== excludedId) {
          position = this.getShapePosition(shapeIdList[i])
          snappableX.push(Math.floor(position.x));
          snappableY.push(Math.floor(position.y));
        }
      }

      let [lineId, index] = IdManage.split(excludedId)


      for (let i = 0; i < lineIdList.length; i ++) {
        for (let j = 1; j < this.lines[lineIdList[i]].points.length - 1; j ++) {
          if (lineId === lineIdList[i] && +index === j) {
          } else {
            snappableX.push(Math.floor(this.lines[lineIdList[i]].points[j].x));
            snappableY.push(Math.floor(this.lines[lineIdList[i]].points[j].y));
          }
        }
      }

      this.snappableX = snappableX
      this.snappableY = snappableY
      this.snappedX = null
      this.snappedY = null
    }

    snap(point) {
      let snappedX = null
        , snappedY = null
        , x, y;

      for (let i = 0; i < this.snappableX.length; i++) {
        if (Math.abs(point.x - this.snappableX[i]) < 10) {

          snappedX = this.snappableX[i];

          break;
        }
      }

      for (let i = 0; i < this.snappableY.length; i++) {
        if (Math.abs(point.y - this.snappableY[i]) < 10) {

          snappedY = this.snappableY[i];

          break;
        }
      }

      this.snappedX = snappedX
      this.snappedY = snappedY

      return {
        x: snappedX === null ? point.x : snappedX,
        y: snappedY === null ? point.y : snappedY
      }

    }

    afterSnap() {
      this.snappedX = null
      this.snappedY = null
      this.snappableX = []
      this.snappableY = []
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/SnappableMixin.js